import easyState, { easyStateDate } from "../../lib/easyState";

const calendarStore = {
  ...easyStateDate("date", new Date()),
  ...easyState("refresh", false)
};

export default calendarStore;
